import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-auth-error',
    templateUrl: './auth-error.component.html',
    standalone: false
})
export class AuthErrorComponent implements OnInit {
  errorCode: string | null = null;
  isUnknownUser = false;

  constructor(private route: ActivatedRoute) { }

  public ngOnInit(): void {
    this.errorCode = this.route.snapshot.queryParamMap.get('c');
    this.isUnknownUser = this.errorCode === '504';
  }
}
